import React from 'react';
import {EnumTypZmenaDokumentu, LogDokumentVO} from '../../../api';
import {downloadDocument} from '../../../api/urls';
import {Col, ListItem, Row} from '@mc/ui-v4';
import {useAppConfig} from '@mc/react-app-base';

export const DocumentChangeItem: React.FC<{featureId: string; log: LogDokumentVO}> = ({featureId, log}) => {
    const {serverContextPath} = useAppConfig();

    let hodnotaPred, hodnotaPo;
    if (log.typ === EnumTypZmenaDokumentu.PRIDANI) {
        hodnotaPred = 'Nevyplněno';
        hodnotaPo = log.idDokument ? (
            <a
                href={`${serverContextPath}${downloadDocument(featureId, log.idDokument)}`}
                target="_blank"
                rel="noopener noreferrer"
                title={log.nazevSoubor}
            >
                {log.nazevSoubor}
            </a>
        ) : (
            log.nazevSoubor
        );
    } else {
        hodnotaPred = log.nazevSoubor;
        hodnotaPo = 'Nevyplněno';
    }
    return (
        <ListItem>
            <Row>
                <Col>příloha</Col>
                <Col>{hodnotaPred}</Col>
                <Col>{hodnotaPo}</Col>
            </Row>
        </ListItem>
    );
};
